"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsOrders_en_us = void 0;
function componentsOrders_en_us() {
    return {
        "components.orders.orderdate": "Order Date",
        "components.orders.orderer": "Orderer",
        "components.orders.empty": "No orders found"
    };
}
exports.componentsOrders_en_us = componentsOrders_en_us;
